// export const apiURL = process.env.REACT_APP_BACKEND_URL;
export const apiURL = process.env.REACT_APP_BACKEND_URL || '/api';

// Base path the embedded Renuka Notify SPA is served under (same-origin via the
// reverse proxy). Notify screens are shown in an iframe under this mount.
export const notifyBase = process.env.REACT_APP_NOTIFY_BASE || '/notify';
